import React from "react";
import RoomListItem from "./RoomListItem";
import Spinner from "./Spinner";
import "./RoomsList.css";

const RoomsList = (props) => {
  return (
    <div className="RoomsList">
      <ul>
        {props.pageItems.map((item) => (
          <RoomListItem
            key={item.id}
            title={item.value.name}
            id={item.id}
            subtitle={`${item.value.width} x ${item.value.height}`}
          />
        ))}
      </ul>

      {props.isLoading ? (
        <Spinner size={props.pageItems === 0 ? "l" : "s"} />
      ) : (
        <div className="buttons" style={{ width: "100%", textAlign: "center" }}>
          <button disabled={!props.hasPrevPage} onClick={props.onPrevPage}>
            <span role="img" aria-label="Newer">
              👈
            </span>
          </button>

          <button disabled={!props.hasNextPage} onClick={props.onNextPage}>
            <span role="img" aria-label="Older">
              👉
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

export default RoomsList;
